module.exports = __webpack_public_path__ + "static/media/rectorat-logo.a6837ca1.png";